export const stickyHeroPlayerState = {
  state: {
    hasUserRejectedSticky: false,
    isTresholdPassed: false,
    isVideoFinished: false,
  },
  setState(key, value) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      this.state[key] = value;
    }
  },
  getState(key) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      return this.state[key];
    }
    return undefined;
  },
};
